import {StaticSwiperListModel} from "../static-swiper/static-swiper-list.model";

export class LiveCasinoListModel extends StaticSwiperListModel {

    protected _applyGameTypesTransformations(gameTypes: number[]): number[] {
        gameTypes = super._applyGameTypesTransformations(gameTypes);
        return this.services.liveTableFeeds.moveGamesThatOpenSoonToTheEnd(gameTypes);
    }
}